<template>
  <div class="generate">
    <!-- Step 1. Check ER Number
         Step 2. If No record related to this ER Number, Show License Type Selection Box
                  Otherwise, show corresponding license record
         Step 3. Show Create Box for User to fill in License Information
    -->
    <el-form :inline="true" :model="checkForm" ref="checkForm" :rules="checkRules" class="demo-form-inline" v-show="showCheckBox">
      <h1>Generate License</h1>
      <el-form-item prop="number">
        <el-input v-model="checkForm.number" placeholder="ER number" @keyup.enter.native="onClickCheck"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" plain @click="onClickCheck" :loading="logining">Check</el-button>
      </el-form-item>
    </el-form>

    <el-form :inline="true" :model="erNumForm" ref="erNumForm" :rules="searchRules" class="demo-form-inline" v-show="showLicenseTypeBox">
      <h1>Generate License</h1>
      <el-form-item prop="option">
        <el-cascader v-model="erNumForm.option" :options="options" ref="eventCascader" @change="elCascaderOnlick"
                     :show-all-levels="false" placeholder="Select License Type"></el-cascader>
      </el-form-item>
      <el-form-item prop="number">
        <el-input v-model="erNumForm.number" v-show="!showFileUpload" @keyup.enter.native="onClickGen" placeholder="ER number"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" plain v-show="!showFileUpload" @click="onClickGen" :loading="logining">Generate</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          class="upload-license" v-show="showFileUpload" v-loading="uploading" ref="upload"
          drag action="uploadRequest" :multiple="false" :limit="1"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :on-exceed="handleUploadExceed"
          :http-request="uploadRequest">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drag file to here or <em>Click to upload file</em></div>
          <div class="el-upload__tip" slot="tip">Please upload the token file</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <el-form>
      <el-table v-show="showLicenseRecord" :data="licenseRecordData" border style="width: 100%"
                :cell-style="{textAlign: 'center'}" :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
        <el-table-column fixed prop="outerlicense" label="Outer License" min-width="105"></el-table-column>
        <el-table-column prop="interlicense" label="Inter License" min-width="105"></el-table-column>
        <el-table-column prop="er_num" label="ER Number" :formatter="arrayFormat"></el-table-column>
        <el-table-column prop="lic_type" label="License Type" :formatter="licTypeFormat"></el-table-column>
        <el-table-column prop="license_content" label="License Content" :formatter="jsonFormat"></el-table-column>
        <el-table-column prop="project" label="Project Name"></el-table-column>
        <el-table-column prop="direct_cus" label="Direct Customer"></el-table-column>
        <el-table-column prop="user_email" label="Customer Email"></el-table-column>
        <el-table-column prop="exp_date" label="Expiry Date [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
        <el-table-column fixed="right" label="Operation" width="220">
          <template slot-scope="scope">
            <el-button-group v-show="showLicenseRecord">
  <!--            <el-button type="primary" plain icon="el-icon-message" @click="onClickView(scope.row)"></el-button>-->
              <el-button type="primary" plain icon="el-icon-edit" @click="onClickModify(scope.row)"></el-button>
              <el-button type="primary" plain icon="el-icon-delete" @click="onClickDelete(scope.row)"
                         v-if="userType === 1"></el-button>
              <el-button type="primary" plain icon="el-icon-download" @click="onClickDownload(scope.row)"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="success" plain v-show="showLicenseRecord" @click="onClickNew()">Confirm to Generate New</el-button>
    </el-form>

    <el-card class="box-card" v-show="showCreateBox">
      <h2>Generate License Form</h2>
      <el-form ref="newLicenseForm" label-position="left" :model="newLicenseForm" :rules="genRules" label-width="150px" :disabled="generating">
        <el-form-item label="Project Name" prop="project">
          <el-input v-model="newLicenseForm.project"></el-input>
        </el-form-item>
        <el-form-item label="Direct Customer" prop="direct_cus" style="text-align:left">
          <el-select v-model="newLicenseForm.direct_cus" filterable placeholder="Please Select"
                     :filter-method="handleCustomerAutoComplete" @change="handleCustomerInputChange" @focus="getCustomerDataList">
            <el-option
              v-for="item in customerData.cus_list"
              :key="item.cus_id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="End Customer" prop="end_cus">
          <el-input v-model="newLicenseForm.end_cus"></el-input>
        </el-form-item>
        <el-form-item label="Expiry Date [as UTC(+00:00)]" prop="exp_date">
          <el-col :span="8">
            <el-date-picker type="date" placeholder="Select Date" :default-value="new Date()" v-model="tmp_exp_date"
                            value-format="yyyy-MM-ddTHH:mm:ss.000Z"
                            @change="OnExpiryDateChange"
                            :disabled="datePickerDisable" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-checkbox v-model="checked" @change="OnCheckBoxChange">No Limit</el-checkbox>
        </el-form-item>
        <el-form-item label="Customer Email" prop="user_email">
          <el-input type="email" v-model="newLicenseForm.user_email" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="ER Number" prop="er_num" style="text-align:left">
          <el-select v-model="newLicenseForm.er_num" disabled multiple placeholder="Enter ER Number"></el-select>
        </el-form-item>
        <el-form-item label="NE Point" prop="ne_point">
          <el-input type="number" v-model="newLicenseForm.ne_point" clearable></el-input>
        </el-form-item>
        <el-form-item label="Enable White Label" prop="white_label" style="text-align:left">
          <el-checkbox v-model="newLicenseForm.white_label"></el-checkbox>
        </el-form-item>
        <el-form-item label="PI Number" prop="pi_num">
          <el-input v-model="newLicenseForm.pi_num"></el-input>
        </el-form-item>
        <el-form-item label="Support Duration" prop="support_dr" style="text-align:left">
          <el-input type="number" v-model="newLicenseForm.support_dr" min="0" style="width: 20%;"
                    @change="OnSupportDrChange"
                    @blur="OnSupportDrChange">
          </el-input>
          (years)
          <br><small style="text-align:left; color:slateblue;">
          {{ newLicenseForm.support_dr_date == null ? "" : newLicenseForm.support_dr_date.format("DD MMM YYYY") }}
        </small>
        </el-form-item>
        <el-form-item label="Sales Name" prop="sales">
          <el-input v-model="newLicenseForm.sales"></el-input>
        </el-form-item>
        <el-form-item label="Sales Email" prop="sales_email">
          <el-input v-model="newLicenseForm.sales_email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" plain @click="generateLicense" :loading="generating">Generate</el-button>
          <el-button type="info" plain @click="onClickCancel">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  checkERNumber,
  downloadLicense,
  generateLicense,
  uploadLicenseTokenFile,
  searchCustomerAutoComplete, getCustomerList
} from '../api'
import moment from 'moment'
export default {
  name: 'Generate',
  data () {
    return {
      testStr: ' ',
      tmp_exp_date: null,
      logining: false,
      generating: false,
      uploading: false,
      showCheckBox: true,
      showLicenseRecord: false,
      showCreateBox: false,
      showFileUpload: false,
      showLicenseTypeBox: false,
      checked: false,
      datePickerDisable: false,
      jsonData: String,
      userType: 0,
      customerData: {},
      licenseRecordData: [],
      newLicenseForm: {
        project: null,
        direct_cus: null,
        end_cus: null,
        exp_date: null,
        user_email: null,
        er_num: null,
        pi_num: null,
        support_dr: null,
        support_dr_date: null,
        lic_type: 0,
        ne_point: 0,
        white_label: false,
        sales: null,
        sales_email: null,
        cus_id: 0
      },
      options: [{
        value: 0,
        label: 'Web License'
      }, {
        value: 1,
        label: 'Local License'
      }],
      checkForm: {
        number: null
      },
      checkRules: {
        number: [
          { required: true, message: 'Please Enter ER Number', trigger: 'blur' }
        ]
      },
      erNumForm: {
        number: null,
        option: []
      },
      searchRules: {
        number: [
          { required: true, message: 'Please Enter ER Number', trigger: 'blur' }
        ],
        option: [
          { type: 'array', required: true, message: 'Please Select a License Type', trigger: 'blur' }
        ]
      },
      genRules: {
        project: [
          { required: true, message: 'Please Enter Project Name', trigger: 'blur' }
        ],
        direct_cus: [
          { required: true, message: 'Please Enter Direct Customer Name', trigger: 'blur' }
        ],
        exp_date: [
          { type: 'date', required: true, message: 'Please Select a Expire Date', trigger: 'blur' }
        ],
        user_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ],
        er_num: [
          { required: true, message: 'Please Enter ER Number', trigger: 'blur' }
        ],
        ne_point: [
          { required: true, message: 'Please Enter NE Point', trigger: 'blur' }
        ],
        sales_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount: function () {
    this.logining = false
    this.generating = false
    this.showCheckBox = true
    this.showLicenseRecord = false
    this.showCreateBox = false
  },
  created: function () {
    this.userType = this.$store.state.usertype
  },
  methods: {
    onClickGen () {
      this.showCreateBox = true
      this.showLicenseTypeBox = false
      this.showCheckBox = false
    },
    onClickCancel () {
      this.showCreateBox = false
      this.showLicenseTypeBox = false
      this.showCheckBox = true
    },
    onClickCheck () {
      const _this = this
      this.$refs.checkForm.validate((valid) => {
        if (valid) {
          this.logining = true
          checkERNumber(_this.checkForm.number).then(data => {
            _this.logining = false
            _this.licenseRecordData = data.data.license_record
            _this.showLicenseRecord = _this.licenseRecordData && _this.licenseRecordData.length > 0
            _this.showLicenseTypeBox = data.data.count === 0
            _this.showCheckBox = !_this.showLicenseTypeBox

            // Set ER Num if no search record
            if (data.data.count === 0) {
              _this.newLicenseForm.er_num = new Array()
              _this.newLicenseForm.er_num.push(_this.checkForm.number)
              _this.erNumForm.number = _this.checkForm.number
            } else {
              _this.newLicenseForm.er_num = new Array()
              _this.newLicenseForm.er_num.push(_this.checkForm.number)
              _this.erNumForm.number = _this.checkForm.number
            }

            console.log('checkERNumber Success -> data.data')
            console.log(data.data)
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            _this.logining = false
          })
        } else {
          console.log('error login!!')
          return false
        }
      })
    },
    getCustomerDataList (val) {
      let that = this
      console.log('getCustomerList val')
      console.log(val)

      getCustomerList().then(data => {
        console.log('getCustomerList Succeed')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    onClickNew () {
      console.log('onClickNew')
      this.showLicenseRecord = false
      this.showLicenseTypeBox = true
      this.showCheckBox = false
    },
    onClickDownload (row) {
      console.log('onClick Download')
      downloadLicense(row.outerlicense, row.interlicense).then(data => {
        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')
        var fileName = 'license_' + row.outerlicense + '.lic'

        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    onClickDelete (row) {
      console.log('Route to DeleteLicense')
      this.$router.push({name: 'DeleteLicense', params: {data: row}})
    },
    onClickModify (row) {
      console.log('Route to ModifyLicense')
      this.$router.push({name: 'ModifyLicense', params: {data: row}})
    },
    handleCustomerAutoComplete (value) {
      const that = this
      console.log('handleCustomerAutoComplete --> value')
      console.log(value)
      searchCustomerAutoComplete(value).then(data => {
        console.log('searchCustomerAutoComplete Success -> data')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
      })
    },
    handleCustomerInputChange (val) {
      console.log('handleCustomerInputChange -> val')
      console.log(val)

      this.newLicenseForm.direct_cus = val.name
      this.newLicenseForm.cus_id = val.cus_id
      this.newLicenseForm.user_email = val.email
    },
    generateLicense () {
      const that = this
      this.$refs.newLicenseForm.validate((valid) => {
        if (valid) {
          that.generating = true
          that.jsonData = {'all_feature': parseInt(that.newLicenseForm.ne_point), 'white_label': that.newLicenseForm.white_label}

          // Convert to Numeric Value
          that.newLicenseForm.support_dr = parseInt(that.newLicenseForm.support_dr)

          // lic_type == 0 (WEB), and lic_type == 1 (LOCAL)
          // Object.assign(that.newLicenseForm, {'lic_type': 0})
          Object.assign(that.newLicenseForm, {'license_content': this.jsonData})

          generateLicense(that.newLicenseForm).then(data => {
            that.showLicenseRecord = true
            that.showOkButton = true
            that.showDownloadButton = true
            that.showCreateBox = false
            that.showCheckBox = false
            that.generating = false

            console.log('generateLicense Success -> data.data')
            console.log(data.data)

            that.licenseRecordData = JSON.parse(JSON.stringify(data.data))

            console.log('update that.licenseRecordData')
            console.log(that.licenseRecordData)
            console.log('length = ', that.licenseRecordData.length)

            that.$router.push({name: 'CompleteLicense', params: {data: data.data}})
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.generating = false
          })
        }
      })
    },
    elCascaderOnlick (value) {
      let that = this
      // 0 - Web, 1 - Local
      that.showFileUpload = value[0] === 1
      that.newLicenseForm.lic_type = value[0]
    },
    handleUploadSuccess (res) {
      this.$notify({
        title: 'Success',
        message: 'Upload File Successfully',
        type: 'success'
      })
    },
    handleUploadError (err) {
      this.$notify({
        title: 'Error',
        message: 'Upload File Failed',
        type: 'error'
      })
      if (err) {
        console.log(err)
      }
    },
    handleUploadExceed (err) {
      this.$notify({
        title: 'Error',
        message: 'Number of Upload File Exceed Limit',
        type: 'error'
      })
      if (err) {
        console.log(err)
      }
    },
    OnCheckBoxChange (value) {
      let that = this

      console.log('OnCheckBoxChange - value = ')
      console.log(value)

      if (value === true) {
        that.newLicenseForm.exp_date = -1
        that.tmp_exp_date = -1
        that.datePickerDisable = true
      } else {
        that.newLicenseForm.exp_date = null
        that.tmp_exp_date = null
        that.datePickerDisable = false
      }
    },
    OnSupportDrChange (value) {
      var tmpDate = moment.utc()

      console.log('OnSupportDrChange - support_dr = ')
      console.log(this.newLicenseForm.support_dr)

      tmpDate.add(this.newLicenseForm.support_dr, 'years')
      this.newLicenseForm.support_dr_date = tmpDate
    },
    OnExpiryDateChange (value) {
      var datum = Date.parse(value)
      this.newLicenseForm.exp_date = datum
    },
    uploadRequest (params) {
      let that = this
      console.log('uploadRequest - params')
      console.log(params)
      that.uploading = true
      that.$refs.upload.clearFiles()

      uploadLicenseTokenFile(params.file).then(data => {
        console.log('uploadLicenseTokenFile Succeed -> data')
        console.log(data)
        that.uploading = false
        console.log('Route to SetHwInfo')
        this.$router.push({name: 'SetHwInfo', params: { data: data['hwInfo'], er_num: that.checkForm.number }})
      }).catch(error => {
        if (error) {
          console.log(error.stack)
          that.$message.error('Search Failed. Please check the token file.')
        }
        that.uploading = false
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD', true)
    },
    jsonFormat: function (row, column) {
      var jsonObj = row[column.property]
      if (jsonObj === undefined) {
        return ''
      }
      const jsonStr = JSON.stringify(jsonObj)
      return jsonStr
    },
    licTypeFormat: function (row, column) {
      var licType = row[column.property]
      if (licType === undefined) {
        return ''
      }
      if (licType === 0) {
        return 'Web'
      }
      if (licType === 1) {
        return 'Local'
      }
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 0px;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// Generate.vue?3f4efe5e